import React, { useState, useEffect } from "react";
import "./HeroWhisky.css";

const HeroWhisky = ({ categoriaSeleccionada, setCategoriaSeleccionada }) => { 
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // 🔁 Detectar resize para cambiar fondo en mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const categorias = ["Ver todos", "JAPONÉS", "ESCOCÉS", "IRLANDÉS", "AMERICANO"];

  const banners = {
    "TODOS": { 
      img: "/img/vistaProductos/backGroundWhisky.jpg",
      imgMobile: "/img/vistaProductos/backGroundWhisky_mobile.jpg", 
      titulo: "Descubrí el whisky que define tu momento.",
      descripcion: "Desde etiquetas clásicas hasta ediciones exclusivas. Explorá nuestra selección y encontrá el whisky perfecto para tu ocasión."
    },
    "JAPONÉS": { 
      img: "/img/inicio/Japones.jpg",
      imgMobile: "/img/vistaProductos/Japones_mobile.jpg", 
      titulo: "La Precisión del Whisky Japonés",
      descripcion: "Descubre la elegancia y meticulosidad del whisky japonés, donde la tradición y la innovación se fusionan en cada gota." 
    },
    "ESCOCÉS": { 
      img: "/img/inicio/Escoces.jpg",
      imgMobile: "/img/vistaProductos/Escoces_mobile.jpg", 
      titulo: "El Legado del Whisky Escocés",
      descripcion: "Sumérgete en la historia y el carácter inigualable del whisky escocés, envejecido con maestría en barricas que narran siglos de perfección." 
    },
    "IRLANDÉS": { 
      img: "/img/inicio/Irlandes.jpg",
      imgMobile: "/img/vistaProductos/Irlandes_mobile.jpg", 
      titulo: "Suavidad y Tradición del Whisky Irlandés",
      descripcion: "Disfruta la esencia del whisky irlandés, conocido por su triple destilación que garantiza una suavidad excepcional y un perfil afrutado único." 
    },
    "AMERICANO": { 
      img: "/img/inicio/Estadounidense.jpg",
      imgMobile: "/img/vistaProductos/Estadounidense_mobile.jpg", 
      titulo: "La Fuerza del Whisky Americano",
      descripcion: "Experimenta la intensidad y el carácter distintivo del whisky estadounidense, con su inconfundible proceso de maduración en barricas de roble nuevo." 
    }
  };

  const { img, imgMobile, titulo, descripcion } = banners[categoriaSeleccionada];
  const backgroundImage = isMobile ? imgMobile : img;

  const handleSelectCategoria = (cat) => {
    setCategoriaSeleccionada(cat === "Ver todos" ? "TODOS" : cat); 
    setIsDropdownOpen(false);
  };

  return (
    <div className="hero-whisky" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="hero-overlay">
        <div className="hero-contentP">
          <h1>{titulo}</h1>
          <h2 className="hero-description">{descripcion}</h2>

          {/* Dropdown */}
          <div className="dropdown-container">
            <button
              className="dropdown-btn text-lowercase"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              {categoriaSeleccionada === "TODOS"
                ? "¿Qué querés tomar hoy?"
                : categoriaSeleccionada} ▼
            </button>

            {isDropdownOpen && (
              <ul className="dropdown-menu text-lowercase">
                {categorias.map((cat) => (
                  <li key={cat} onClick={() => handleSelectCategoria(cat)}>
                    {cat}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroWhisky;
